<span [ngClass]="isSubHeader ? 'nested-nav-title' : 'nav-title'" [class.active]="isDropdownOpen" (click)="toggleDropdown()">
  {{headerTitle}}
  <i class="nav-icon fa fa-angle-right dropdown-icon" [ngClass]="{'rotate': isDropdownOpen}" aria-hidden="true"></i>
</span>

<div class="dropdown-content" [ngClass]="{'show': isDropdownOpen}">
  <ng-content></ng-content>
</div>
